import { mediaQuery } from '@/styles/media';
import { useEffect } from 'react';
import styled from 'styled-components';

type Props = {
  url: string;
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: center;

  ${mediaQuery.sp} {
    justify-content: flex-start;
  }
`;

const Item = styled.li`
  padding-bottom: 6px;

  &:not(:first-child) {
    margin-left: 10px;
  }

  &:nth-child(3) {
    padding-bottom: 0;
  }

  ${mediaQuery.sp} {
    &:not(:first-child) {
      margin-left: 8px;
    }
  }
`;

const ShareButtons: React.FC<Props> = ({ url }) => {
  useEffect(() => {
    if (window.FB) {
      window.FB.XFBML.parse();
    }
  }, []);
  return (
    <>
      <Wrapper>
        <List>
          <Item>
            <a
              href="https://b.hatena.ne.jp/entry/"
              className="hatena-bookmark-button"
              data-hatena-bookmark-layout="vertical-normal"
              data-hatena-bookmark-lang="ja"
              title="このエントリーをはてなブックマークに追加"
            >
              <img
                src="https://b.st-hatena.com/images/v4/public/entry-button/button-only@2x.png"
                alt="このエントリーをはてなブックマークに追加"
              />
            </a>
          </Item>
          <Item>
            <a
              href="https://x.com/share?ref_src=twsrc%5Etfw"
              className="twitter-share-button"
              data-lang="ja"
              data-show-count="false"
            >
              Post
            </a>
          </Item>
          <Item>
            <div id="fb-root" />
            <div
              className="fb-like"
              data-href={url}
              data-width="84"
              data-layout="box_count"
              data-action="like"
              data-size="small"
              data-share="false"
            />
          </Item>
          <Item>
            {/* biome-ignore lint/a11y/useValidAnchor: Pocketのexampleに従う */}
            <a
              data-pocket-label="pocket"
              data-pocket-count="vertical"
              className="pocket-btn"
              data-lang="en"
            >
              pocket
            </a>
          </Item>
        </List>
      </Wrapper>
    </>
  );
};

export default ShareButtons;
